<template>
  <AppHeader>Create Feedback</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Topic</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.topic" name="topic" required>
          <option value="General Feedback">General Feedback</option>
          <option value="Cash Balance Request">Cash Balance Request</option>
          <option value="New Feature">New Feature</option>
          <option value="Reporting Bug">Reporting Bug</option>
          <option value="Dealer Related">Dealer Related</option>
          <option value="Wallet Related">Wallet Related</option>
          <option value="Delivery Related">Delivery Related</option>
          <option value="Subscription Related">Subscription Related</option>
          <option value="Product Related">Product Related</option>
          <option value="Customer Related">Customer Related</option>
          <option value="Others">Others</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.topic">{{ errors.topic }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Priority</p>
        <div class="flex justify-start mt-2 gap-x-2">
          <button class="px-3 py-1 text-xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.priority == 'Low'}" @click="form.priority = 'Low'">Low</button>
          <button class="px-3 py-1 text-xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.priority == 'Medium'}" @click="form.priority = 'Medium'">Medium</button>
          <button class="px-3 py-1 text-xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.priority == 'High'}" @click="form.priority = 'High'">High</button>
        </div>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.priority">{{ errors.priority }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Message</p>
        <textarea class="w-full text-xl placeholder:text-lg" v-model="form.message" name="message" placeholder="Enter your Message here..." rows="6"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.message">{{ errors.message }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createFeedback">Create Feedback</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CreateFeedback',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'idle',
      form: { topic: 'General Feedback', priority: 'Low' },
    }
  },

  methods: {
    createFeedback() {
      let rules = {
        topic: 'required',
        priority: 'required',
        message: 'required',
      };

      if (!this.validateForm(this.form, rules)) return;
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';
      this.form.message += ' - ' + this.$store.state.platform;

      this.request('POST', 'feedback', this.form, (resp) => {
        this.state = 'idle';
        alert(resp.message ? resp.message : 'Sorry, Please try again.');
        if (resp.success) this.form = { topic: 'General Feedback', priority: 'Low' };
      });
    }
  },

  created() {
    if (!this.$store.state.user.id) this.$router.push('/dash');
  }
}
</script>
